angular.module("prisma")
.factory('ngAuthSettings', function () {
    var settings = {};

    settings.apiServiceBaseUri = "/api/"
    settings.clientId = 'ngAuthApp';

    return settings;
});
